import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <Section className="bg-[#060f1c] pt-4 md:pt-16 pb-6 md:pb-12" data-id="element-327" data-mp="mz5y1ndih8kh">
      <div className="max-w-4xl mx-auto text-center space-y-3 md:space-y-8" data-id="element-328" data-mp="rsqsx6jt5mfg">
        <FadeIn data-id="element-329" data-mp="wqa9id3zabak">
          <div className="space-y-2 md:space-y-6" data-id="element-330" data-mp="wqsgo4s6i9x9">
            {/* Changed container to inline-flex, added gap, new BG, and modified texts */}
            <div className="inline-flex items-center gap-1.5 bg-white/10 text-white font-bold px-3 py-1 rounded-full md:mb-2 text-[11px] md:text-[14px] border border-white/10" data-id="element-331" data-mp="42efjg5smxhh">
              <span className="text-base" data-id="element-332" data-mp="943sj1cktl87">⚽</span>
              <span className="text-brandOrange" data-id="element-333" data-mp="e1vivqxkozaa">EL ARSENAL DEL PROFE™</span>
            </div>
            {/* Updated h1 with new font size, layout, and styling */}
            <h1 className="font-extrabold text-white text-[30px] md:text-5xl lg:text-6xl leading-[1.1] tracking-tight px-2" data-id="element-334" data-mp="1pfzaiqgoubc6">
              Todas tus clases de
              <br data-id="element-335" data-mp="1h9sj2bkb3qyj" />
              <span className="text-brandOrange" data-id="element-336" data-mp="1h87tz1grh082">educación física.</span>
              <br data-id="element-337" data-mp="1cbqytnb59llh" />
              <span className="text-white" data-id="element-338" data-mp="1c94pbi4p0w0m">Listas. Desde hoy.</span>
            </h1>
            {/* Changed paragraph styling to smaller font, different color, and padding */}
            <p className="text-gray-300 text-[13px] md:text-base font-medium px-3 leading-snug" data-id="element-339" data-mp="13a17ehh9imnp">
              Sesiones · Juegos · Clases listas · Primaria · Secundaria · Sin
              materiales
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-340" data-mp="oldfcl6mkv2i">
          <a href="#pricing" className="block cursor-pointer" data-id="element-341" data-mp="omojim3zg4u5">
            <img src="https://cdn.magicpatterns.com/uploads/m24tX2QfVjgY5cQRyyupXG/quiero_que_me_202604132324_-_Editado.png" alt="El Arsenal del Profe — Mockup del MegaPack" width={1024} height={1024} loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="block w-full max-w-[260px] md:max-w-xl mx-auto h-auto object-contain hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-342" data-mp="kk1oydfxg5t9" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-343" data-mp="3n7uagedrchro">
          <div className="max-w-2xl mx-auto space-y-3 md:space-y-6" data-id="element-344" data-mp="3s418lkzwwoz2">
            {/* Desktop chips */}
            <div className="hidden md:flex flex-wrap gap-2 flex-row items-end justify-center" data-id="element-345" data-mp="johi2tqmlknp">
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm pt-[7px] pb-[7px]" data-id="element-346" data-mp="oo3u4zupwuux">
                <span className="text-base" data-id="element-347" data-mp="ex95xpxwvl6u">📄</span> 100% PDF
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-348" data-mp="12nvbnakg0tdo">
                <span className="text-base" data-id="element-349" data-mp="2s4qy5bghlj81">⚡</span> Acceso en 5 minutos
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-350" data-mp="2s2eaqirymgnl">
                <span className="text-base" data-id="element-351" data-mp="31wmvgkar15b7">🇦🇷</span> Primaria + Secundaria
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-352" data-mp="2wxk23x44snj2">
                <span className="text-base" data-id="element-353" data-mp="248mkzxbnowrw">🎯</span> Sin materiales + Con
                materiales
              </span>
              <span className="bg-white/15 text-white px-3 py-1.5 rounded-full text-xs md:text-sm font-medium inline-flex items-center gap-1.5 border border-white/20 backdrop-blur-sm" data-id="element-354" data-mp="2i487nxuf34h5">
                <span className="text-base" data-id="element-355" data-mp="3tnt2lkow039z">📚</span> 120+ actividades listas
              </span>
            </div>

            {/* Mobile chips */}
            <div className="flex md:hidden flex-nowrap gap-1.5 justify-center items-center" data-id="element-356" data-mp="opfab722db99">
              <span className="bg-white/10 text-white px-2.5 py-1.5 rounded-full text-[11px] font-semibold inline-flex items-center gap-1 border border-white/15 whitespace-nowrap shrink-0" data-id="element-357" data-mp="spz4q2v960rp">
                <span className="text-xs" data-id="element-358" data-mp="12oexsbdubk3u">📄</span> PDF
              </span>
              <span className="bg-white/10 text-white px-2.5 py-1.5 rounded-full text-[11px] font-semibold inline-flex items-center gap-1 border border-white/15 whitespace-nowrap shrink-0" data-id="element-359" data-mp="12mbw2u3bs2ja">
                <span className="text-xs text-brandOrange" data-id="element-360" data-mp="1bna03cdrka1v">⚡</span> Acceso
                Inmediato
              </span>
              <span className="bg-white/10 text-white px-2.5 py-1.5 rounded-full text-[11px] font-semibold inline-flex items-center gap-1 border border-white/15 whitespace-nowrap shrink-0" data-id="element-361" data-mp="1lf6b1o0y7uni">
                <span className="text-xs" data-id="element-362" data-mp="1qcfywz8ovy98">🇦🇷</span> Argentina
              </span>
            </div>

            {/* Call-to-action button and info */}
            <div className="space-y-2.5 md:space-y-3 md:pt-2" data-id="element-363" data-mp="3fw62qisg9sss">
              {/* Updated button styles for size, font, and border-radius */}
              <CTAButton href="#pricing" fullWidth className="text-base md:text-xl py-4 md:py-5 animate-glow-button !rounded-2xl md:!rounded-full font-black tracking-wide" trackEvent={{
              name: 'Lead',
              params: {
                content_name: 'Hero CTA — Quiero el MegaPack',
                content_category: 'engagement'
              }
            }} data-id="element-364" data-mp="3ayo3xl85ctyi">
                💪 → QUIERO EL MEGAPACK AHORA
              </CTAButton>

              {/* Changed pricing info layout and styles for baseline alignment, icon size, and gaps */}
              <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-4 text-[10px] md:text-xs text-gray-400 font-medium pt-1" data-id="element-365" data-mp="l7rhb95aw8z5">
                <span className="flex items-center gap-1" data-id="element-366" data-mp="2ao4v3dxhws4p">
                  <ShieldCheck size={13} className="text-green-500" data-id="element-367" data-mp="2aon0p161sipa" /> Garantía
                  30 días
                </span>
                <span className="flex items-center gap-1" data-id="element-368" data-mp="2fp0xfn278680">
                  <Lock size={13} className="text-gray-400" data-id="element-369" data-mp="20xio283uh9xm" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-370" data-mp="25w3ni5b9vpl0">
                  <CreditCard size={13} className="text-blue-400" data-id="element-371" data-mp="1rxvkbfnn7s1e" />
                  <span className="md:hidden" data-id="element-372" data-mp="1rzq5mv2ttm60">Tarjetas | Mercado Pago</span>
                  <span className="hidden md:inline" data-id="element-373" data-mp="1w00eqglx0sp3">
                    Mercado Pago | Tarjeta | Transferencia
                  </span>
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const SocialProof = () => {
  return <div className="bg-[#070f1e] border-y border-white/10 py-6" data-id="element-374" data-mp="3ce09ld5wls5h">
      <div className="max-w-6xl mx-auto px-4" data-id="element-375" data-mp="3hctnh6p3rl66">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-white/10" data-id="element-376" data-mp="3hbs8ws8vogjp">
          <FadeIn delay={0.1} data-id="element-377" data-mp="15n3ytzpeeiy9">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-378" data-mp="10qdkbgt8rvey">
              +500
            </div>
            <div className="text-xs text-gray-300 font-medium" data-id="element-379" data-mp="1ff9rlbnh54ei">
              profes confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-380" data-mp="1amq85y23vf1s">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-381" data-mp="1ofpp84hjdhbg">
              6
            </div>
            <div className="text-xs text-gray-300 font-medium" data-id="element-382" data-mp="1jh4om3ydgvmh">
              Tomos listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-383" data-mp="1ycub037gzarq">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-384" data-mp="1ybt1w4a0kycn">
              6
            </div>
            <div className="text-xs text-gray-300 font-medium" data-id="element-385" data-mp="3zutg4jj46ht">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-386" data-mp="3v6xk8uvggari">
            <div className="text-2xl md:text-3xl font-bold text-brandOrange mb-0.5" data-id="element-387" data-mp="3v7qit8k9ftyk">
              4.9/5
            </div>
            <div className="text-xs text-gray-300 font-medium flex items-center justify-center gap-1" data-id="element-388" data-mp="39b5pkcymrp65">
              calificación{' '}
              <Star size={12} className="fill-yellow-400 text-yellow-400" data-id="element-389" data-mp="3j29uejuldtn9" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Llegué al lunes con todo listo. Los juegos sin materiales me salvaron.',
    author: 'Marcelo R., Buenos Aires',
    role: 'Profe de Ed. Física'
  }, {
    initials: 'CP',
    text: '40 chicos y poco espacio. El bono de Espacios Chicos lo resolvió.',
    author: 'Carolina P., Córdoba',
    role: 'Escuela Primaria'
  }, {
    initials: 'DG',
    text: 'Domingo a la noche: 10 minutos y la clase del lunes lista.',
    author: 'Diego G., Rosario',
    role: 'Secundaria Técnica'
  }];
  return <div className="bg-[#060f1c] py-6 md:py-8 px-4" data-id="element-390" data-mp="245gxxfpviosh">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-391" data-mp="244xefukkrscc">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-392" data-mp="1vdeynkrjjejs" data-mpi={i}>
            <div className="bg-[#0c1626] p-3 md:p-4 rounded-xl border border-white/10 h-full flex flex-col" data-id="element-393" data-mp="1vbu6g1sp87p3">
              <div className="flex items-center gap-2.5 mb-2" data-id="element-394" data-mp="1qe24eeycb576">
                <div className="w-8 h-8 md:w-9 md:h-9 bg-brandOrange text-white rounded-full flex items-center justify-center font-bold text-[11px] md:text-xs shrink-0" data-id="element-395" data-mp="1lgaaxgi1rb0v">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-396" data-mp="1cf2nxukzdwm3">
                  <div className="flex text-yellow-400 mb-0.5" data-id="element-397" data-mp="17fpsilg1nh7w">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-398" data-mp="36stx6szeeeh0" data-mpi={j} />)}
                  </div>
                  <p className="font-bold text-white text-[11px] md:text-xs leading-tight truncate" data-id="element-399" data-mp="31usc62iew52w">
                    {t.author}
                  </p>
                  <p className="text-[10px] text-gray-400 truncate" data-id="element-400" data-mp="dctujuqljrj1">{t.role}</p>
                </div>
              </div>
              <p className="text-gray-300 text-[12px] md:text-[13px] italic leading-snug flex-grow" data-id="element-401" data-mp="rcl3vi664jqp">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </div>;
};
export const Problem = () => {
  const painPoints = ['Domingos buscando juegos en YouTube que no encajan', 'Clases armadas a las corridas la noche anterior', 'Siempre los mismos juegos, sin un banco real', 'Día de lluvia sin plan B y el grupo descontrolado', 'Grupos grandes, poco espacio, sin saber qué hacer', 'Alumnos de secundaria que se aburren y no participan'];
  return <Section className="bg-[#070f1e] text-white" data-id="element-402" data-mp="3c193deitowvv">
      <div className="max-w-3xl mx-auto" data-id="element-403" data-mp="373h5m3vhygjr">
        <FadeIn data-id="element-404" data-mp="372pgnbwenh2g">
          <h2 className="text-2xl md:text-5xl font-extrabold text-center mb-6 md:mb-10 uppercase tracking-tight md:tracking-wide text-white leading-[1.15]" data-id="element-405" data-mp="3737bc43f5n89">
            Si sos profe de <span className="text-brandOrange" data-id="element-406" data-mp="1rd6nk71t5pg8">ed. física</span>
            ,
            <br data-id="element-407" data-mp="1dl9zce39fzp4" />
            esto te va a{' '}
            <span className="text-brandOrange" data-id="element-408" data-mp="1dml34dwph7g8">sonar familiar...</span>
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10 md:mb-14" data-id="element-409" data-mp="1ikcv17xcotkf">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-white/5 border border-white/10 rounded-xl md:rounded-2xl p-2.5 md:p-4 hover:bg-white/[0.07] transition-colors" data-id="element-410" data-mp="26a755hqac40z" data-mpi={i}>
                <XCircle className="text-red-400 shrink-0 mt-0.5 md:mt-1 w-4 h-4 md:w-6 md:h-6" data-id="element-411" data-mp="21acgzlxw9sjm" />
                <p className="text-gray-300 text-[13px] md:text-base leading-snug" data-id="element-412" data-mp="kw2r2ne07vqo">
                  {point}
                </p>
              </div>)}
          </div>

          <h3 className="text-2xl md:text-4xl font-bold text-center text-white mb-6 md:mb-8" data-id="element-413" data-mp="pt2xizern0ib">
            ¿Cuánto tiempo más vas a{' '}
            <span className="text-brandOrange" data-id="element-414" data-mp="1qxyd2mvakbk">seguir perdiendo</span>?
          </h3>

          <div className="space-y-3 md:space-y-4 text-base md:text-lg text-gray-200 mb-10 md:mb-12 text-center md:text-left" data-id="element-415" data-mp="3t65cqai1tqoe">
            <p data-id="element-416" data-mp="3o7u23xjxjc54">
              Elegiste esta profesión porque amás el movimiento, el deporte y
              ver a tus alumnos crecer.
            </p>
            <p data-id="element-417" data-mp="3j5uzwqzxel9r">
              Pero nadie te dijo que ibas a perder los domingos buscando juegos
              que no encajan con tu grupo, armando clases a último momento y
              llegando el lunes improvisando algo que "más o menos sirve".
            </p>
          </div>

          <div className="bg-[#060f1c] border-2 border-brandOrange rounded-2xl md:rounded-3xl p-5 md:p-8 text-center" data-id="element-418" data-mp="359r9z9w34z33">
            <p className="text-lg md:text-2xl font-extrabold uppercase tracking-wide text-white leading-tight" data-id="element-419" data-mp="18dtqbxugfpdh">
              ¿Y si esta fuera{' '}
              <span className="text-brandOrange" data-id="element-420" data-mp="1b145hmuybbu7">la última clase</span> que
              preparás así?
            </p>
          </div>
        </FadeIn>
      </div>
    </Section>;
};